function EmptyPlaceholder(props) {
  return (
    <svg
      id='EmptyPlaceholder'
      // version='1.1'
      // x={'0px'}
      // y={'0px'}
      viewBox='0 0 472.955 472.955'
      // style={{ enableBackground: 'new 0 0 472.955 472.955' }}
      xmlSpace='preserve'
      {...props}
    >
      <path
        d='M391.355,426.899c-24.197-107.151-53.805-176.001-69.301-207.506c-7.718-15.685-12.272-32.5-13.535-49.974l-0.009-0.122
	c-0.172-2.315-0.291-6.629-0.288-6.934c0.351-35.749,20.959-144.335,21.167-145.428c0.419-2.198-0.674-4.407-2.676-5.408l-22-11
	c-1.487-0.744-3.25-0.698-4.699,0.121c-1.449,0.82-2.394,2.308-2.522,3.968c-0.737,9.576-3.05,20.521-5.63,30.4
	c-18.38,1.516-36.991,2.293-55.384,2.293c-18.392,0-37.006-0.778-55.391-2.295c-3.059-11.739-4.988-22.127-5.624-30.398
	c-0.128-1.66-1.073-3.147-2.522-3.968s-3.211-0.866-4.699-0.121l-22,11c-2.001,1.001-3.095,3.209-2.676,5.408
	c0.238,1.252,23.826,125.561,20.942,151.512c-0.008,0.073-0.015,0.146-0.02,0.219c-0.586,8.781-2.036,17.538-4.311,26.029
	c-2.286,8.531-5.406,16.84-9.277,24.697c-15.495,31.503-45.103,100.353-69.301,207.505c-0.472,2.089,0.44,4.248,2.267,5.366l49,30
	c1.32,0.809,2.941,0.96,4.389,0.409s2.558-1.741,3.007-3.223l3.288-10.842c17.225,3.486,34.798,6.02,52.384,7.549l-0.671,5.641
	c-0.285,2.391,1.175,4.644,3.472,5.363c12.346,3.862,25.043,5.793,37.742,5.793c12.699,0,25.398-1.931,37.744-5.793
	c2.297-0.719,3.756-2.972,3.472-5.362l-0.671-5.641c17.586-1.53,35.159-4.063,52.383-7.549l3.288,10.842
	c0.449,1.482,1.56,2.672,3.007,3.223c0.575,0.219,1.178,0.327,1.778,0.327c0.91,0,1.815-0.249,2.611-0.736l49-30
	C390.915,431.146,391.827,428.988,391.355,426.899z M174.214,172.514c14.564,2.018,29.188,3.332,43.831,3.928
	c-2.548,3.645-4.045,8.076-4.045,12.85c0,4.479,1.322,8.652,3.589,12.161c-15.942-0.63-31.863-2.071-47.718-4.297
	C172.02,189.102,173.475,180.829,174.214,172.514z M248.956,189.291c0,6.88-5.598,12.478-12.478,12.478S224,196.172,224,189.291
	c0-6.798,5.466-12.334,12.233-12.466c0.082,0,0.163,0.002,0.245,0.002c0.081,0,0.162-0.002,0.244-0.002
	C243.489,176.958,248.956,182.493,248.956,189.291z M254.905,176.442c14.646-0.596,29.273-1.911,43.84-3.929
	c0.741,8.376,2.186,16.605,4.33,24.643c-15.856,2.226-31.779,3.667-47.723,4.296c2.27-3.51,3.604-7.679,3.604-12.161
	C258.956,184.515,257.454,180.086,254.905,176.442z M231.483,64.44c-14.122-0.192-28.323-1.192-42.324-2.994
	c-1.14-3.255-3.113-9.084-5.21-16.161c15.792,1.216,31.728,1.881,47.534,1.998V64.44z M241.483,47.283
	c15.801-0.117,31.73-0.782,47.513-1.996c-2.102,7.094-4.067,12.911-5.202,16.16c-13.996,1.801-28.192,2.801-42.311,2.994V47.283z
	 M154.091,18.784l12.193-6.097c1.329,9.706,3.89,21.091,7.644,33.963c3.51,12.034,6.728,20.727,6.863,21.091
	c0.642,1.728,2.182,2.962,4.008,3.213c17.067,2.34,34.454,3.526,51.679,3.526c17.226,0,34.613-1.187,51.679-3.526
	c1.826-0.25,3.366-1.485,4.008-3.213c0.492-1.325,11.073-30.011,14.505-55.054l12.194,6.097
	c-3.708,19.801-20.315,110.229-20.641,143.477c-0.001,0.053-0.001,0.134-0.002,0.227c-41.001,5.761-82.503,5.76-123.505-0.002
	C174.402,129.019,157.81,38.639,154.091,18.784z M340.385,450.358L295.262,301.55c-0.8-2.643-3.592-4.136-6.235-3.334
	c-2.643,0.801-4.136,3.593-3.334,6.235l40.798,134.547c-16.661,3.336-33.651,5.758-50.65,7.225L262.313,332.41
	c-0.326-2.742-2.809-4.703-5.555-4.375c-2.742,0.326-4.701,2.813-4.374,5.555l14.881,125.194c-20.224,5.558-41.348,5.558-61.572,0
	l14.29-120.129c0.326-2.742-1.632-5.229-4.374-5.555v0c-2.742-0.326-5.229,1.632-5.556,4.374l-12.937,108.748
	c-17-1.467-33.99-3.889-50.652-7.225l40.798-134.547c0.802-2.643-0.691-5.434-3.334-6.235c-2.641-0.802-5.435,0.691-6.235,3.334
	L132.57,450.358L92.149,425.61c23.82-104.156,52.593-171.036,67.725-201.8c2.698-5.476,5.05-11.159,7.045-16.976
	c23.091,3.317,46.325,4.998,69.56,4.998c23.231,0,46.461-1.68,69.549-4.997c1.984,5.775,4.332,11.44,7.054,16.972
	c15.133,30.767,43.906,97.647,67.726,201.803L340.385,450.358z'
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  )
}

export default EmptyPlaceholder
